import React from 'react';
import { Box, Circle, Heading, Text, VStack } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { formatBytes } from 'utils/file/formatBytes';
import { mimeTypeToUserFriendlyString } from 'utils/file/MIMETypeUtils';
import { FileIcon } from 'components/icons/FileIcon';
import { FileRenderer_node$data } from '../__generated__/FileRenderer_node.graphql';
import { DownloadButton } from 'components/Item/ItemMenu/components/ShareButton/components/DownloadButton';
import { contentFromNode } from '..';
import { ApplicationCrashedIcon } from 'components/icons';

export interface UnsupportedFileRendererProps {
  node: FileRenderer_node$data;
  hasError?: boolean;
}

export const UnsupportedFileRenderer = ({
  node,
  hasError,
}: UnsupportedFileRendererProps) => {
  const { size, mimeType, name } = contentFromNode(node);
  const fileType = mimeTypeToUserFriendlyString(mimeType);
  return (
    <VStack maxWidth={800} mt={4}>
      {hasError ? (
        <Error />
      ) : (
        <Box fontSize="80px" color="blue.500">
          <FileIcon mimeType={mimeType} />
        </Box>
      )}
      <VStack spacing={0}>
        <Text fontWeight={700}>{name}</Text>
        <Text fontSize="sm">
          {(size && formatBytes(size)) || t`Unknown Size`}
        </Text>
      </VStack>
      {!hasError && (
        <Text color="gray.500" as="i" align="center">
          {t`${fileType} files are not supported`}
        </Text>
      )}
      <DownloadButton node={node} webViewerNotAvailable />
    </VStack>
  );
};

const Error = () => (
  <>
    <Circle bg="red.300" size="90px">
      <ApplicationCrashedIcon size="3x" color="white" />
    </Circle>
    <Heading fontSize="xl">Sorry, something went wrong</Heading>
    <Text textAlign="center">The document viewer encountered an error</Text>
  </>
);
